import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloCancelInstall } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { environmentQueryKeys } from '../queries/query-keys';
import { EnvironmentId } from '../types';

/** Stops a KubeSolo install, including kubesoloctl on the machine. Resolves once it has stopped. */
export function useCancelKubesoloInstallMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (environmentId: EnvironmentId) =>
      kubesoloCancelInstall({ path: { id: environmentId } }),
    ...withInvalidate(queryClient, [environmentQueryKeys.base()]),
    ...withError('Unable to cancel the KubeSolo install'),
  });
}
